import { FC,Dispatch } from 'react';
import { Setting } from '../../App';
import classes from '../../asset/css/pickup/pickup-shipping-product-list.module.css';
import { SubscriptionType } from '../../types/api/subscriptions-api-type';
import { ProductInfoViewType, ProductItemPickUpType } from '../../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../../types/view/recommend-product-info-view-type';
import { PickupProductItemPickup } from './PickupProductItemPickup';

export const PickupProductListPickup: FC<{
  pickUpProducts: ProductItemPickUpType[];
  loading: boolean;
  setting: Setting;
  addProductSuccess: (showModal: boolean) => void;
  failed: (message: string) => void;
  setSubscriptionContractId: Dispatch<string>;
  setRegisteredProducts: Dispatch<ProductInfoViewType[]>;
  setPausedProducts: Dispatch<ProductInfoViewType[]>;
  setRecommendProducts: Dispatch<RecommendProductInfoViewType[]>;
  setSubscription: Dispatch<SubscriptionType>;
  max?: number;
}> = ({
  pickUpProducts,
  loading,
  setting,
  addProductSuccess,
  failed,
  setSubscriptionContractId,
  setPausedProducts,
  setRecommendProducts,
  setRegisteredProducts,
  setSubscription,
  max
}) => {
  const products = max ? pickUpProducts.slice(0, max) : pickUpProducts;

  if (products.length === 0) {
    return <></>;
  }

  return (
    <ul className={classes.pickup_products_list_pickup}>
      {products.map((product, index) => (
        <PickupProductItemPickup
          key={`pickupItem_${index}`}
          loading={loading}
          productItem={product}
          message={product.message}
          setting={setting}
          addProductSuccess={addProductSuccess}
          failed={failed}
          setSubscriptionContractId={setSubscriptionContractId}
          setRegisteredProducts={setRegisteredProducts}
          setPausedProducts={setPausedProducts}
          setRecommendProducts={setRecommendProducts}
          setSubscription={setSubscription}
        />
      ))}
    </ul>
  );
};
